import { getErrorMessage } from 'application/util/error.util';

import './forgot-password-reset.style.sass';
import template from './forgot-password-reset.tpl.pug';

class ForgotPasswordResetController {
    /* @ngInject */
    constructor($state, $stateParams, resetPasswordService) {
        this.$state = $state;
        this.resetPasswordService = resetPasswordService;

        this.token = $stateParams.token || null;
    }

    resetPassword(password) {
        return this.resetPasswordService.reset(this.token, password).then(() => {
            this.$state.go('identity.sign-in');
        }, (result) => {
            this.error = getErrorMessage(result, `We were not able to reset your password.`);
        });
    }
}

export default {
    selector: 'dbAForgotPasswordReset',
    template: template(),
    controller: ForgotPasswordResetController
};



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/forgot-password/scene/forgot-password-reset/forgot-password-reset.cmpt.js